<template>
  <picker-field
    :label="label"
    :value="value"
    :is-focus="isFocus"
    title="选择阶段"
    ref="picker"
    @open="onSearch"
  >
    <template v-slot:tbar>
      <search-bar
        @search="onSearch"
        @focus="onFocusChange"
        name="pj_dename,pp_name"
        placeholder="输入项目名称、阶段名称查找"
        ref="searchBar"
        :auto-search="true"
      />
    </template>
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <div
        class="weui-cell weui-cell_access"
        v-for="item in items"
        :key="item.pp_id"
        @click="select(item)"
      >
        <div class="weui-cell__bd">
          <p>{{ item.pj_dename }}</p>
          <p  class="list-item-muted">{{ item.pj_code }} &nbsp;{{ item.pj_emname }}</p>
        </div>
        <div class="weui-cell__ft">
          <p>{{ item.pp_name }}</p>
        </div>
      </div>
    </scroll-list>
  </picker-field>
</template>

<script>
import PickerField from "@/components/field/PickerField.vue";
import SearchBar from "@/components/SearchBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import querylist from "@/mixins/querylist.js";

export default {
  components: {
    PickerField,
    SearchBar,
    ScrollList,
  },
  mixins: [querylist],
  props: {
    label: {
      type: String,
      default: "选择人员",
    },
    value: String,
    listUrl: {
      type: String,
      default: "/api/plm/proj/list",
    },
    extraParams: Object
  },
  data() {
    return {
      isFocus: false,
      allowEmptySearch: false,
      defaultCondition: [{
        field: "pj_statuscode ",
        operation: "=",
        value: "AUDITED"
      }]
    }
  },
  methods: {
    select(item) {
      var me = this;
      me.$emit("input", item.pp_name);
      me.$emit("select", item);
      me.$refs.picker.close();
    },
    onFocusChange(focus) {
      this.isFocus = focus;
    }
  },
};
</script>